import { render, staticRenderFns } from "./roomOdds.vue?vue&type=template&id=64f59e74&lang=pug&"
import script from "./roomOdds.vue?vue&type=script&lang=js&"
export * from "./roomOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports